export const ZoneColors = [
    '#f97316', // Orange
    '#ec4899', // Pink
    '#8b5cf6', // Purple
    '#06b6d4', // Cyan
    '#10b981', // Green
    '#f59e0b', // Amber
    '#ef4444', // Red
    '#3b82f6', // Blue
    '#e11d88', // Rose
    '#0ea5e9', // Sky
    '#22c55e', // Lime
    '#a855f7', // Violet
    '#d97706', // Yellow-Orange
    '#14b8a6'  // Teal
];

export const ZoneNames = [
'Proximal_Zone_1',
'Distal_Zone_2',
'Lateral_Zone_3',
'Medial_Zone_4',
'Posterior_Zone_5',
'Anterior_Zone_6',
'Superior_Zone_7',
'Inferior_Zone_8',
'Central_Zone_9',
'Outer_Zone_10',
'Inner_Zone_11',
'Oblique_Zone_12',
'Transverse_Zone_13',
'Sagittal_Zone_14'
];